// Cloudscape global styles (base typography, reset, and design tokens). This is
// the single design system for the app. JetBrains Mono is the self-hosted mono
// face for identifiers/code; it ships woff2 locally via @fontsource so there's
// no runtime network dependency.
import '@cloudscape-design/global-styles/index.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import IntlProvider from '@amzn/bui-intl/lib/components/intl-provider';
import { I18nProvider } from 'react-aria';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { loadRuntimeConfig } from './config/appConfig';

function AppRoot() {
    const appLocale = 'en-US';
    return (
        <React.StrictMode>
            <IntlProvider
                locale={appLocale}
                messageLoader={async (locale: string) =>
                    (await import(`@translations/strings-${locale}.puff.json`)).default
                }
            >
                <I18nProvider locale={appLocale}>
                    <App />
                </I18nProvider>
            </IntlProvider>
        </React.StrictMode>
    );
}

const el = document.getElementById('root');

if (el) {
    const root = createRoot(el);
    // Load the per-stage runtime config (/config.json) before rendering so AWS
    // services are configured from the deployed stack outputs.
    loadRuntimeConfig()
        .then(() => {
            root.render(<AppRoot />);
        })
        .catch((err: unknown) => {
            root.render(
                <div role="alert" style={{ padding: 24, fontFamily: 'sans-serif' }}>
                    Failed to load application configuration. Please try again later.
                    <pre>{String(err)}</pre>
                </div>,
            );
        });
}
